import { makeClinicSlug } from './shared';
import cloudflareLoader from './cloudflare';
import { sanitizeImageUrl } from './images';
import { License, SpecialityChannel } from '@/types/algolia-types';

const GMAPS_QUERY_URL = 'https://www.google.com/maps/search/?api=1&query=';

export const getMapLink = (address: string = '') => {
  const addressEncoded = encodeURIComponent(address);
  return `${GMAPS_QUERY_URL}${addressEncoded}`;
};

export const makeMarkersList = (
  items: {
    _geoloc?: { lat: number; lng: number };
    name: string;
    license: License;
    specializations: { specialityChannels?: SpecialityChannel[]; label: string };
    logoUrl?: string | null;
    address?: string | null;
    cap?: string | null;
    slug: string;
    city?: string | null;
  }[],
) => {
  const markers = [];
  for (const item of items) {
    if (
      !item?._geoloc?.lat ||
      !item?._geoloc?.lng ||
      !item?.name ||
      !item?.license ||
      item.specializations?.specialityChannels?.includes(SpecialityChannel.Online)
    )
      continue;
    const markerItem = {
      lat: item._geoloc.lat,
      lng: item._geoloc.lng,
      label: item?.name,
      slug: makeClinicSlug(item, item?.specializations?.label ?? ''),
      isLicensed: item.license !== License.None,
      logo: item.logoUrl ? sanitizeImageUrl(cloudflareLoader({ src: item.logoUrl, width: 100 })) : undefined,
      address: `${item.address}, ${item.cap} ${item.city}`,
    };
    if (item.license !== License.None) markers.push(markerItem);
    else markers.unshift(markerItem);
  }
  return markers;
};

export const generateMapUuid = (items: { ambulatoryId: string }[]) => {
  const ids = [];
  for (const item of items) {
    if (!item?.ambulatoryId) continue;
    ids.push(item?.ambulatoryId);
  }
  return Buffer.from(ids.join(''), 'utf-8').toString('base64');
};
